import { Component } from "react";
import "../../../../styles/css/table.scss";
import "../../../../App.css";
import { connect } from "react-redux";
import apis from "../../../../Providers.Api/apis";
import Helper from "../../../../Common/Helper";
import Spinner from "../../../../Components/Navigation/LoadingSpinner/Spinner";
import { SelectChangeEvent } from "@mui/material/Select";
import { RouteComponentProps, RouterProps } from "react-router-dom";
import { appContext } from "../../../../AppContext";
import IbssDataGrid from "../../../../Components/Data/DataGrid/IbssDataGrid";
import { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import IbssFormControl from "../../../../Components/Forms/FormControl/IbssFormControl";
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import IbssPageHeader from "../../../../Components/Forms/DateRange/IbssPageHeader";
import { DateTime } from "luxon";
import IbssButtonRedo from "../../../../Components/Buttons/Button/IbssButton";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import CreateIcon from '@mui/icons-material/Create';
import CloseIcon from '@mui/icons-material/Close';
import IbssActionButton, { IActionButton } from "../../../../Components/Buttons/ActionButton/IbssActionButton";
import AddIcon from '@mui/icons-material/Add';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Box, Button, Grid } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import IbssDialog from "../../../../Components/Dialogs/BaseDialog/IbssDialog";
import { IDispatch, IPropsFromState } from "../../../../redux/Interfaces";
import BookingStatus from "../../../../Components/Miscellaneous/BookingStatus/BookingStatus";
import TimeZoneOffset from "../../../../Components/Miscellaneous/TimeZoneOffset/TimeZoneOffset";
import { ODataQuery } from "../../../../Providers.Api/ODataQuery";
import { Visit2, VisitFilter } from "../../../../Providers.Api/Visits/VisitsRepository";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import React from "react";
import UserPicker, * as UserPickerModule from "../../../../Components/Inputs/UserPicker/UserPicker";
import CreateVisitorDialog from "../../../../Components/Dialogs/CreateVisitorDialog/CreateVisitorDialog";
import RefreshIcon from '@mui/icons-material/Refresh';
import customTheme from "../../../../customTheme";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { Constants } from "../../../../Common/Constants";
import { StringHelper } from "../../../../Common/StringHelper";
import { QueryParams } from "./QueryParams";
import QRCode from "react-qr-code";
import { renderToString } from 'react-dom/server';
import { DateRangeHelper } from "../../../../Components/Core/BasePage/DateRangeHelper";
import { Space } from "../../../../Providers.Api/Spaces/SpaceRepository";

class ListVisits extends IbssPage<IProps, IState, QueryParams>
{
    private get alert() { return appContext().alert; }
    private get appState() { return appContext().state; }
    private get local() { return appContext().localStorageProvider; }
    private get visitsService() { return appContext().visitsService; }
    private get labels() { return appContext().labels; }
    private visitorPassesContainer = React.createRef<HTMLDivElement>();
    private visitorPasses: React.RefObject<HTMLDivElement>[] = [];
    private get apiClient() { return appContext().apiClient; }
    private isFlex = this.area == 'flex';
    private string = new StringHelper();
    private isOnelens = this.area == 'onelens';
    private get apiCache() { return appContext().apiCache; }
    private cachedSpaces: Space[] = [];
    private pageCacheKey = '27a0d6ff-2cd7-fe94-2061-aa192db33bae';

    constructor(props: IProps)
    {
        super(props, new QueryParams());
        this.state =
        {
            canExport: false,
            canImport: false,
            canCreateVisits: false,
            canUpdateVisits: false,
            isRefreshButtonDisabled: true,
            searchTerm: "",
            daysFilter: "",
            visits: [],
            bookingStartDate: DateTime.now(),
            bookingEndDate: DateTime.now(),
            filterStatusOption: [
                { label: this.labels.HubTabAwaitingApproval, value: "Awaiting Approval" },
                { label: this.labels.HubLabelCancelled, value: "Cancelled" },
                { label: this.labels.HubLabelDeniedLabel, value: "Denied" },
                { label: this.labels.HubLabelApproved, value: "Approved" },
                { label: this.labels.HubLabelCheckedIn, value: "Checked In" },
                { label: this.labels.HubLabelCheckedOut, value: "Checked Out" },
                { label: this.labels.HubLabelNoShow, value: "No Show" },
                { label: this.labels.HubLabelAutoCancelledStatus, value: "Auto Cancelled" },
            ],
            selectedHost: { label: "", email: "" },
            dialogSelectedHost: { label: "", email: "" },
            dialogHostName: "",
            filterValue: "",
            dateDisabled: true,
            selectedVisitIds: [],
            isCompleteLoading: false,
            cancelButtonEnabled: false,
            approveButtonEnabled: false,
            denyButtonEnabled: false,
            checkInButtonEnabled: false,
            checkOutButtonEnabled: false,
            printPassButtonEnabled: false,
            showDeny: false,
            denyComment: "",
            isFileUpload: false,
            file: { name: "" },
            showPrintPass: false,
            showFilterDialog: false,
            showAddVisitorModal: false,
            buildingId: this.appState.buildingId,
            visitStatus: "",
            badgeHtml: '',
            userHasApproveRights: false,
            userHasDenyRights: false,
            userHasCheckinRights: false,
            userHasCheckoutRight: false,
        }
    }

    public async componentDidMount(): Promise<void>
    {
        if (this.isOnelens)
        {
            try
            {
                const file = await this.apiClient.files.getFileAsBlob(`c/Badge/${this.state.buildingId}/badge.html`, true);
                const htmlText = await file.text();
                this.setState({ badgeHtml: htmlText });
            } catch (error)
            {
                try
                {
                    const file = await this.apiClient.files.getFileAsBlob(`c/Badge/badge.html`, true);
                    const htmlText = await file.text();
                    this.setState({ badgeHtml: htmlText });
                } catch (error)
                {
                }
            }
        }

    }
    public async queryParamsDidUpdate(firstLoad: boolean): Promise<void>
    {
        if (firstLoad)
        {
            appContext().inMemoryCache.clear(i => i.startsWith(this.pageCacheKey + '_'));
        }

        const string = this.string;
        const queryParams = this.queryParams;
        const buildingId = queryParams.building ?? 1;
        const status = this.state.filterStatusOption.find(i => string.toKebabCase(i.value) == queryParams.status) ?? null;
        const currentUser = this.local.getUserDetails();
        const host = (this.isFlex ? currentUser.email : queryParams.host);
        const defaultPeriod = (this.isFlex ? this.labels.HubLabelThisWeek : this.labels.HubLabelToday);
        
        const dateRange = new DateRangeHelper(buildingId)
        .addToday()
        .addTomorrow()
        .addThisWeek()
        .addNextWeek()
        .addThisMonth()
        .addNextMonth()
        .getDateRange(queryParams.period, defaultPeriod, queryParams.start, queryParams.end);
        
        await this.setStateAsync({
            buildingId: buildingId,
            daysFilter: dateRange.period,
            dateDisabled: (dateRange.period != this.labels.HubLabelCustom),
            bookingStartDate: dateRange.start,
            bookingEndDate: dateRange.end,
            filterValue: status?.value ?? '',
            selectedHost: { label: '', email: host ?? '' },
            dialogHostName: host ?? '',
            searchTerm: queryParams.filter ?? '',
            isCompleteLoading: true,
        });
        
        const building = this.local.getNodeData().Regions.flatMap(i => i.Buildings).find(i => i.Node_Id == this.state.buildingId) ?? null;
        this.pageTitle = this.isFlex ? this.labels.HubMenumySchedule : this.labels.HubLabelFacilityManagement + (building == null ? '' : ' - ' + building.Name);
        this.cachedSpaces = await this.apiCache.getSpacesByBuilding(buildingId);
        await this.loadRights(this.state.buildingId);
        await this.loadVisits();
        this.enableRefreshButtonAfterTimeOut();       
    }

    private loadRights(buildingId: number): void
    {
        this.setState({
            canExport: this.local.hasRight("API.Visits.Export"),
            canImport: this.local.hasRight("API.Visits.Import"),
            canCreateVisits: this.local.hasRight("DATAMODEL.Visits.Create"),
            canUpdateVisits: this.local.hasRight("DATAMODEL.Visits.Update"),
            userHasApproveRights: this.local.permissionAppliesToBuilding('API.Visits.Approve', buildingId) && this.local.hasRight("API.Visits.Approve"),
            userHasDenyRights: this.local.permissionAppliesToBuilding('API.Visits.Deny', buildingId) && this.local.hasRight("API.Visits.Deny"),
            userHasCheckinRights: this.local.permissionAppliesToBuilding('API.Visits.CheckIn', buildingId) && this.local.hasRight("API.Visits.CheckIn"),
            userHasCheckoutRight: this.local.permissionAppliesToBuilding('API.Visits.CheckOut', buildingId) && this.local.hasRight("API.Visits.CheckOut"),
        });
    }

    private queuePushQueryParamsTimeout: (NodeJS.Timeout | null) = null;
    private queuePushQueryParams(queryParams: Partial<QueryParams>): void
    {
        clearTimeout(this.queuePushQueryParamsTimeout ?? undefined);
        this.queuePushQueryParamsTimeout = setTimeout(() => this.pushQueryParams(queryParams), Constants.longDebounceTimeInMilliseconds);
    }

    private async loadVisits(): Promise<void>
    {
        try
        {
            if (!this.state.bookingStartDate.isValid || !this.state.bookingEndDate.isValid)
            {
                await this.setStateAsync({ visits: [] });
                return;
            }

            const endpoint = {
                name: 'visitsService.getMany',
                query: new ODataQuery({
                    top: 1001,
                    nodeId: this.state.buildingId,
                    select: Visit2,
                    filter: new VisitFilter({
                        minStartDate: this.state.bookingStartDate.date().setZoneByNode(this.state.buildingId),
                        maxEndDate: this.state.bookingEndDate.date().plus({ days: 1 }).setZoneByNode(this.state.buildingId),
                        status: this.state.filterValue,
                        hostEmail: this.state.selectedHost.email,
                    })
                })
            };

            const visits = await appContext().inMemoryCache.lazyGetWithQuickExpiry(
                `${this.pageCacheKey}_${JSON.stringify(endpoint)}`,
                () => this.visitsService.getMany(endpoint.query)
            );

            if (visits.value.length > 1000)
            {
                this.alert.show("", this.labels.TooManySearchResults_L);
            }

            const visitsView = visits.value.slice(0, 1000).map(i => ({ id: i.Visit_Id, ...i }));
            await this.setStateAsync({ visits: visitsView });
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private get filteredVisits(): Visit2[] 
    {
        const searchTerm = this.state.searchTerm;
        const lowerSearchTerm = searchTerm.toLowerCase();

        const filteredVisits = this.state.visits.filter(visit =>
        {
            let key: keyof Visit2;
            for (key in visit)
            {
                const value = visit[key]?.toString().toLowerCase();
                if (value && value.includes(lowerSearchTerm)) 
                {
                    return true;
                }
            }
            return false;
        });
        return filteredVisits;
    }

    private get selectedVisits(): Visit2[]
    {
        return this.filteredVisits.filter(row => this.state.selectedVisitIds.includes(row.Visit_Id));
    }

    private async selectionChanged(selection: GridRowSelectionModel): Promise<void>
    {
        await this.setStateAsync({ selectedVisitIds: selection });
        this.enableDisableActionButtons();
    }

    private enableDisableActionButtons(): void
    {
        const selectedVisits = this.selectedVisits;
        const cancellableRows = selectedVisits.filter(i => i.Visit_Status == "New" || i.Visit_Status == "Amended" || i.Visit_Status == "Late Checkin" || i.Visit_Status == "Awaiting Approval" || i.Visit_Status == "Approved");
        const approvableRows = selectedVisits.filter(i => i.Visit_Status == "Awaiting Approval");
        const checkInableRows = selectedVisits.filter(i => i.Visit_Status == "Approved");
        const checkOutableRows = selectedVisits.filter(i => i.Visit_Status == "Checked In");
        const printableRows = selectedVisits.filter(i => i.Visit_Status == "Checked In" || i.Visit_Status == "Approved");

        this.setState({
            cancelButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == cancellableRows.length),
            approveButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == approvableRows.length),
            denyButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == approvableRows.length),
            checkInButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == checkInableRows.length),
            checkOutButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == checkOutableRows.length),
            printPassButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == printableRows.length) && (this.local.permissionAppliesToBuilding('ONELENS360.OperationalServices.VisitorPass', this.state.buildingId) && this.local.hasRight("ONELENS360.OperationalServices.VisitorPass")),
        });
    }

    private async cancelManyClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";
        const selectedVisitsByNodeId: { [key: number]: Visit2[] } = {};

        this.selectedVisits.forEach(visit =>
        {
            if (!Object.hasOwnProperty.call(selectedVisitsByNodeId, visit.Node_Id)) 
            {
                selectedVisitsByNodeId[visit.Node_Id] = [];
            }
            selectedVisitsByNodeId[visit.Node_Id].push(visit);
        });

        try 
        {
            for (const nodeId in selectedVisitsByNodeId) 
            {
                if (Object.hasOwnProperty.call(selectedVisitsByNodeId, nodeId)) 
                {
                    const selectedVisitIdsForNodeId = selectedVisitsByNodeId[nodeId].map(x => x.Visit_Id)
                    await this.visitsService.cancel(Number(nodeId), selectedVisitIdsForNodeId);
                }
            }
            await this.loadVisits();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async approveVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id);
        try
        {
            await this.visitsService.approve(this.appState.buildingId, selectedVisitIds, '')
            await this.loadVisits();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async denyVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id);

        try
        {
            await this.visitsService.deny(this.appState.buildingId, selectedVisitIds, this.state.denyComment)
            await this.loadVisits();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false, showDeny: false });
        }
    }

    private async checkInVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id);
        try
        {
            await this.visitsService.checkin(this.appState.buildingId, selectedVisitIds)
            await this.loadVisits();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async checkOutVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id)
        try
        {
            await this.visitsService.checkout(this.appState.buildingId, selectedVisitIds)
            await this.loadVisits();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async hostChanged(selectedHost: UserPickerModule.IUser | null): Promise<void>
    {
        this.setState({
            dialogSelectedHost: {
                label: selectedHost?.label || selectedHost?.email || "",
                email: selectedHost?.email ?? "",
            }
        });
    }

    private async dateRangeChanged(e: SelectChangeEvent<string>): Promise<void>
    {
        const datePreset = this.string.toKebabCase(e.target.value);
        const customPeriod = this.string.toKebabCase(this.labels.HubLabelCustom);
        const datePresetIsCustom = (datePreset == customPeriod);

        this.pushQueryParams({
            period: datePreset,
            start: (datePresetIsCustom ? this.state.bookingStartDate : undefined),
            end: (datePresetIsCustom ? this.state.bookingEndDate : undefined),
        });
    }

    private async startDateChanged(e: DateTime): Promise<void>
    {
        await this.setStateAsync({ isCompleteLoading: true });
        this.queuePushQueryParams({ start: e });
    }

    private async endDateChanged(e: DateTime): Promise<void>
    {
        await this.setStateAsync({ isCompleteLoading: true });
        this.queuePushQueryParams({ end: e });
    }

    private denyModelCancelled(): void 
    {
        this.setState({ showDeny: !this.state.showDeny });
    }

    private denyButtonClicked(): void
    {
        this.setState({ showDeny: !this.state.showDeny });
    }

    private fileUploadModalClosed(): void
    {
        this.setState({ isFileUpload: !this.state.isFileUpload });
    }

    private selectedFileChanged(e: React.ChangeEvent<HTMLInputElement>) 
    {
        this.setState({ file: e.target.files?.[0] });
    }

    private async uploadFileButtonClicked(): Promise<void> 
    {
        this.setState({ isCompleteLoading: true });
        this.fileUploadModalClosed();
        const formData = new FormData();

        const file = (this.state.file ? this.state.file : "");
        formData.append('file', file as string);
        formData.append('fileName', (file as IFile).name);

        try
        {
            const res = await apis.visitorImportFile(this.appState.buildingId, formData);
            if (res.status === 200)
            {
                let messageHtml = `<h2>${this.labels.HubLabelFileuploadedsuccessfully}</h2> </br>`;

                const erroredEntries = res.data.filter((x: { ImportSuccessful: boolean; }) => x.ImportSuccessful == false);
                const successfulEntries = res.data.filter((x: { ImportSuccessful: boolean; }) => x.ImportSuccessful == true);

                if (erroredEntries.length > 0)
                {
                    messageHtml = `<h2>${successfulEntries.length}/${res.data.length} ${this.labels.HubLabelEntriesUploadedSuccessfully}</h2><h3>${this.labels.HubLabelIssuesOccured}:</h3>` + res.data.filter((x: { ImportSuccessful: boolean; }) =>
                        x.ImportSuccessful == false).map((i: { Error: { RowNo: number, Message: string } }) =>
                            `<span>${this.labels.HubLabelRow} ${i.Error?.RowNo ? i.Error?.RowNo + 1 : '-'} ${i.Error?.Message?.length > 0 ? `- ${i.Error?.Message}` : ''}</span> </br>`).join('');
                }
                this.alert.show("", messageHtml, () => { }, { messageIsHtml: true });
            }
            else
            {
                this.alert.show("", res.statusText ?? this.labels.HubLabelSomethingWentWrong);
            }
        }
        catch (error)
        {
            const typedError = error as { Message: string };
            this.alert.show("", typedError.Message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async downloadVisitsClicked(): Promise<void> 
    {
        const email = this.local.getUserDetails().email;
        const filteredVisitorsObj = {
            buildingId: this.state.buildingId,
            startDate: this.state.bookingStartDate.date().setZoneByNode(this.state.buildingId).startOf('day').toUTC().toISO(),
            endDate: this.state.bookingEndDate.date().setZoneByNode(this.state.buildingId).endOf('day').toUTC().toISO(),
            statusValue: this.state.filterValue,
            host: this.state.selectedHost.email.toLowerCase(),
            email: email.toLowerCase(),
            type: this.isFlex ? "flex" : "oneLens"
        }
        try
        {
            await apis.downloadExcelFilterVisitors(filteredVisitorsObj);
        }
        catch (error) { }

    }

    private async printPassButtonClicked(): Promise<void>
    {
        this.visitorPasses = this.state.selectedVisitIds.map(() => React.createRef());
        await this.setStateAsync({ showPrintPass: !this.state.showPrintPass });
        const selectedVisitors = this.state.visits.filter(x => this.state.selectedVisitIds.includes(x.Visit_Id));

        let imageUrl = '';
        const firstVisitLogo = this.visitorPasses[0].current?.querySelector(`#visit-logo`);
        if (firstVisitLogo)
        {
            const fileBlob = await this.apiClient.files.getFileAsBlob(firstVisitLogo.innerHTML);
            imageUrl = URL.createObjectURL(fileBlob);
        }

        selectedVisitors.forEach(async (visitor, index) =>
        {
            const visitorPass = this.visitorPasses[index].current;
            const qrCodeType = this.visitorPasses[index].current?.querySelector(`#qr-code`)?.innerHTML.split('-')[0];
            const qrCodeSize = this.visitorPasses[index].current?.querySelector(`#qr-code`)?.innerHTML.split('-')[1];
            const qrCodeValue = qrCodeType == 'pacs' ? visitor.Visit_Pacs_Id : qrCodeType == 'visitId' ? visitor.Visit_Id : '';
            if (visitorPass == null)
            {
                return;
            }

            const startDate = DateTime.fromISO(visitor.Visit_Start_Date);
            const endDate = DateTime.fromISO(visitor.Visit_End_Date);

            const visitorName = visitorPass.querySelector(`#visitor-name`);
            const visitorCompany = visitorPass.querySelector(`#visitor-company`);
            const visitDate = visitorPass.querySelector(`#visit-date`);
            const visitTime = visitorPass.querySelector(`#visit-time`);
            const visitHost = visitorPass.querySelector(`#visit-host`);
            const visitLogo = visitorPass.querySelector(`#visit-logo`);
            const qrCode = visitorPass.querySelector(`#qr-code`);

            if (visitorName) visitorName.innerHTML = visitor.Visitor_First_Name + ' ' + visitor.Visitor_Last_Name;
            if (visitorCompany) visitorCompany.innerHTML = visitor.Visitor_Company;
            if (visitDate) visitDate.innerHTML = startDate.toLocaleDateString();
            if (visitTime) visitTime.innerHTML = startDate.toLocaleTimeString() + ' - ' + endDate.toLocaleTimeString();
            if (visitHost) visitHost.innerHTML = visitor.Visit_Host_Name;
            if (visitLogo) visitLogo.innerHTML = `<img src=${imageUrl}>`;
            if (qrCode) qrCode.innerHTML = renderToString((qrCodeType == 'pacs' && visitor.Visit_Pacs_Id.length > 0) || qrCodeType == 'visitId' ? <QRCode size={qrCodeSize ? parseInt(qrCodeSize) : undefined} value={qrCodeValue} /> : <div></div>);

        });
    }

    private addVisitButtonClicked(): void
    {
        this.setState({ showAddVisitorModal: true });
    }

    private editVisitButtonClicked(param: Visit2): void
    {
        const { history } = this.props;
        if (this.isFlex)
        {
            history.push(`/flex-my-visitor/${param.Node_Id}/myvisit/${param.Visit_Id}`);
        }
        else
        {
            history.push(`/operational-services-Visitors/${this.appState.buildingId}/visit/${param.Visit_Id}/1`);
        }
    }

    private async filterButtonClicked(): Promise<void>
    {
        await this.setStateAsync({
            showFilterDialog: true,
            dialogHostName: this.state.selectedHost.email,
            dialogSelectedHost: { label: this.state.selectedHost.label, email: this.state.selectedHost.email },
        });
    }

    private filterModalClosed(): void
    {
        this.setState({ showFilterDialog: false });
    }

    private async filterModalOkButtonClicked(): Promise<void>
    {
        try
        {
            this.pushQueryParams({
                status: this.string.toKebabCase(this.state.filterValue),
                host: (this.isFlex ? undefined : this.state.dialogSelectedHost.email),
            });
        }
        finally
        {
            this.setState({ showFilterDialog: false });
        }
    }


    private getStartTime(row: Visit2): string
    {
        return DateTime.fromISO(row.Visit_Start_Date).offsetTimeByNode(row.Node_Id, false).toLocaleTimeString();
    }

    private getEndTime(row: Visit2): string
    {
        return DateTime.fromISO(row.Visit_End_Date).offsetTimeByNode(row.Node_Id, false).toLocaleTimeString();
    }

    private async modalClosed(submitted?: boolean): Promise<void>
    {
        this.setState({ showAddVisitorModal: !this.state.showAddVisitorModal });
        if (submitted)
        {
            await this.loadVisits();
        }
    }

    private enableRefreshButtonAfterTimeOut(): void
    {
        setTimeout(() =>
        {
            this.setState({ isRefreshButtonDisabled: false });
        }, 60000);
    }

    private async handleRefreshButtonClick(): Promise<void>
    {
        this.setState({ isRefreshButtonDisabled: true });
        await this.loadVisits();
        this.enableRefreshButtonAfterTimeOut();
    }

    private async handleSearchTermChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): Promise<void>
    {
        this.setState({ searchTerm: event.target.value });
        this.queuePushQueryParams({ filter: event.target.value });
    }

    private getFloorName(spaceId: string): React.ReactNode 
    {
        const Id = spaceId.split(";")[0];
        const floors = Helper.getFloorsByBuildingId(this.state.buildingId);
        const floorNodeId = this.cachedSpaces.find(x => x.Space_Id === Id)?.Node_Id;
        return floors.find(x => x.Node_Id === floorNodeId)?.Node_Name;
    }

    public render(): JSX.Element
    {

        const visitColumns: GridColDef[] = [
            {
                headerName: this.labels.HubLabelDate,
                field: "Date",
                minWidth: 140,
                flex: 1,
                valueGetter: (params) => DateTime.fromISO(params.row.Visit_Start_Date).toLocaleDateString(),
            },
            {
                headerName: this.labels.HubLabelArrival,
                field: "Visit_Start",
                minWidth: 140,
                flex: 1,
                valueGetter: (params) => this.getStartTime(params.row),
            },
            {
                headerName: this.labels.HubLabelDeparture,
                field: "Visit_End",
                minWidth: 140,
                flex: 1,
                valueGetter: (params) => this.getEndTime(params.row),
            },
            {
                headerName: this.labels.HubLabelTimeZone,
                cellClassName: "table-cell-font",
                field: "timeZone",
                minWidth: 100,
                flex: 1,
                renderCell: (params) => <TimeZoneOffset nodeId={params.row.Node_Id} />
            },
            {
                headerName: this.labels.HubLabelvisitor,
                field: "Visitor_Name",
                minWidth: 120,
                flex: 1,
                valueGetter: (params) => params.row.Visitor_First_Name + ' ' + params.row.Visitor_Last_Name
            },
            {
                headerName: this.labels.HubLabelCompany,
                field: Helper.nameOf<Visit2>("Visitor_Company"),
                minWidth: 140,
                flex: 1
            },
            {
                headerName: this.labels.funcDestination_S,
                field: Helper.nameOf<Visit2>("Space_Name"),
                minWidth: 140,
                flex: 1,
                valueGetter: (params) => params.row.Space_Name?.length > 0 ? params.row.Space_Name : '-'
            },
            {
                headerName: this.labels.HubLabelFloors,
                field: "Floor",
                minWidth: 140,
                flex: 1,
                renderCell: (params) => params.row.Space_Id ? this.getFloorName(params.row.Space_Id) : '-'
            },
            {
                headerName: this.labels.HubLabelAction,
                minWidth: 100,
                flex: 1,
                field: "",
                filterable: false,
                sortable: false,
                renderCell: (params) => this.renderEdit(params.row)
            },
            {
                headerName: this.labels.HubLabelStatus,
                field: "Visit_Status",
                minWidth: 140,
                flex: 1,
                renderCell: (params) => <BookingStatus status={params.row.Visit_Status} />,
                valueGetter: (params) => params.row.Visit_Status,
            }];

        if (!this.isFlex)
        {
            visitColumns.splice(5, 0,
                {
                    headerName: this.labels.HubLabelHostName,
                    field: Helper.nameOf<Visit2>("Visit_Host_Name"),
                    minWidth: 160,
                    flex: 1
                })
        }

        let actions: IActionButton[] = [
            {
                label: this.labels.funcRefreshBookings_S,
                icon: (
                    <IbssSvgIcon sx={{ color: this.appState.lightModeTheme ? customTheme.lightTheme.uiTextAlternate : customTheme.darkTheme.uiTextAlternate }}>
                        <RefreshIcon />
                    </IbssSvgIcon>),
                color: "inherit",
                labelColor: this.appState.lightModeTheme ? customTheme.lightTheme.uiTextAlternate : customTheme.darkTheme.uiTextAlternate,
                onClick: () => this.handleRefreshButtonClick(),
                disabled: this.state.isRefreshButtonDisabled
            },
            {
                label: this.labels.HubButtonApprove,
                icon: (
                    <IbssSvgIcon>
                        <CheckCircleIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.approveButtonEnabled || !this.state.userHasApproveRights,
                onClick: () => this.approveVisitorClicked()
            },
            {
                label: this.labels.HubButtonDeny,
                icon: (
                    <IbssSvgIcon>
                        <CloseIcon />
                    </IbssSvgIcon>
                ),
                color: "primary",
                disabled: !this.state.denyButtonEnabled || !this.state.userHasDenyRights,
                onClick: () => this.denyButtonClicked()
            },
            {
                label: this.labels.HubButtonCancel,
                icon: (
                    <IbssSvgIcon>
                        <CloseIcon />
                    </IbssSvgIcon>),
                color: "error",
                disabled: !this.state.cancelButtonEnabled || !this.state.canUpdateVisits,
                onClick: () => this.cancelManyClicked(),
            },
            {
                label: this.labels.HubButtonCheckIn,
                icon: (
                    <IbssSvgIcon>
                        <CheckCircleIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.checkInButtonEnabled || !this.state.userHasCheckinRights,
                onClick: () => this.checkInVisitorClicked()
            },
            {
                label: this.labels.HubButtonCheckOut,
                icon: (
                    <IbssSvgIcon>
                        <CancelIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.checkOutButtonEnabled || !this.state.userHasCheckoutRight,
                onClick: () => this.checkOutVisitorClicked()
            },
            {
                label: this.labels.HubButtonPrintPass,
                icon: (
                    <IbssSvgIcon>
                        <AccountBalanceWalletIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.printPassButtonEnabled || this.state.badgeHtml == '',
                onClick: () => this.printPassButtonClicked()
            },
            {
                label: this.labels.HubButtonAdd,
                icon: (
                    <IbssSvgIcon>
                        <AddIcon />
                    </IbssSvgIcon>
                ),
                color: "primary",
                disabled: !this.state.canCreateVisits,
                onClick: () => this.addVisitButtonClicked(),
            }];

        if (this.isFlex)
        {
            actions = actions.filter(i => i.label == this.labels.HubButtonCancel || i.label == this.labels.HubButtonAdd || i.label == this.labels.funcRefreshBookings_S);
        }

        return (
            <>
                <div className="">
                    <IbssDialog
                        aria-modal="true"
                        aria-label="filter visitors modal"
                        onClose={() => this.filterModalClosed()}
                        open={this.state.showFilterDialog}
                        header={this.labels.HubLabelFilter}
                        fullWidth
                        dialogContent={
                            <>
                                <div className="row">
                                    <div className="form-input-box">
                                        <label className="form-input-box-label visit-filter-label">{this.labels.HubLabelStatus}</label>
                                        <div className="form-input-select-box">
                                            <select className="custom-form-control visit-filter-selectbox select-box-border" onChange={(e) => this.setState({ filterValue: e.target.value })} value={this.state.filterValue} >
                                                <option></option>
                                                {this.state.filterStatusOption.map((option: IFilterStatus) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {!this.isFlex &&
                                    <div className="row">
                                        <div className="form-input-box">
                                            <label className="form-input-box-label visit-filter-label">{this.labels.HublabelHostVisitFilter}</label>
                                            <UserPicker
                                                width="calc(100% - 110px)"
                                                searchText={this.state.dialogHostName}
                                                label=""
                                                placeholder="&#8230;"
                                                alternateStyle={true}
                                                onChange={async text => await this.setStateAsync({ dialogHostName: text })}
                                                onUserChange={user => this.hostChanged(user)}
                                            />
                                        </div>
                                    </div>
                                }
                            </>
                        }
                        footer={
                            <>
                                <IbssButtonRedo
                                    onClick={() => this.filterModalClosed()}
                                    color="secondary"
                                    variant="outlined"
                                    className="mr-2"
                                >
                                    {this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <IbssButtonRedo
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    className="ml-2"
                                    onClick={() => this.filterModalOkButtonClicked()}
                                >
                                    {this.labels.HubLabelOk}
                                </IbssButtonRedo>
                            </>
                        }
                    />
                    <IbssDialog
                        aria-modal="true"
                        aria-label="import visitors modal"
                        onClose={() => this.fileUploadModalClosed()}
                        open={this.state.isFileUpload}
                        header={this.labels.HublabelUploadFile}
                        fullWidth
                        dialogContent={
                            <>
                                <div className="row mt-3">
                                    <div className="col-3 pl-0 ">
                                        <label className="upload-file-modal-label pr-0">{this.labels.HubLabelFile}</label>
                                    </div>
                                    <div className="col-8 pl-0 file-picker">
                                        <input className="upload-file-modal-input" value={this.state.file?.name} type="text" readOnly></input>
                                        <label htmlFor="filePicker" className="button-outline file-picker-label mr-1">{this.labels.HubLabeSelectFile}</label>
                                        <input id="filePicker" className="hideInput" type={"file"} onChange={(e) => this.selectedFileChanged(e)}></input>
                                    </div>
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <div className="d-flex justify-content-center w-100">
                                    <IbssButtonRedo
                                        onClick={() => this.fileUploadModalClosed()}
                                        color="secondary"
                                        variant="outlined"
                                        className="mr-2"
                                    >
                                        {this.labels.HubButtonCancel}
                                    </IbssButtonRedo>
                                    <IbssButtonRedo
                                        color="primary"
                                        variant="contained"
                                        size="medium"
                                        className="ml-2"
                                        onClick={() => this.uploadFileButtonClicked()}
                                    >
                                        {this.labels.HubLabelOk}
                                    </IbssButtonRedo>
                                </div>
                            </>
                        }
                    />
                    <IbssDialog
                        aria-modal="true"
                        aria-label="deny modal"
                        onClose={() => this.denyModelCancelled()}
                        open={this.state.showDeny}
                        header={this.labels.HubButtonDeny}
                        fullWidth
                        dialogContent={
                            <>
                                <div className="col-12">
                                    <label>{this.labels.HubLabelComment}</label>
                                    <input className="input-box border model-textbox" type="text" name="denyComment" value={this.state.denyComment} onChange={(e) => this.setState({ denyComment: e.target.value })} />
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <IbssButtonRedo
                                    color="secondary"
                                    variant="outlined"
                                    className="mr-2" onClick={() => this.denyModelCancelled()}>{this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <IbssButtonRedo
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    disabled={!this.state.denyComment}
                                    onClick={() => this.denyVisitorClicked()}>{this.labels.HubLabelOk}
                                </IbssButtonRedo>
                            </>
                        }
                    />
                    {/* --Print pass modal-- */}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="print pass modal"
                        onClose={() => this.setState({ showPrintPass: !this.state.showPrintPass })}
                        fullWidth
                        open={this.state.showPrintPass}
                        dialogContent={
                            <>
                                <div ref={this.visitorPassesContainer}>
                                    {
                                        this.state.selectedVisitIds.map((id, index) => (
                                            <div key={id} ref={this.visitorPasses[index]} dangerouslySetInnerHTML={{ __html: this.state.badgeHtml }}></div>
                                        ))
                                    }
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <IbssButtonRedo
                                    color="secondary"
                                    variant="outlined"
                                    className="mr-2" onClick={() => this.setState({ showPrintPass: !this.state.showPrintPass })}>{this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <ReactToPrint
                                    content={() => this.visitorPassesContainer.current}
                                    onAfterPrint={() => this.setState({ showPrintPass: false })}
                                    removeAfterPrint
                                >
                                    <PrintContextConsumer>
                                        {({ handlePrint }) => (
                                            <IbssButtonRedo
                                                color="primary"
                                                variant="contained"
                                                size="medium"
                                                className="ml-2" onClick={handlePrint}>{this.labels.HubButtonPrint}
                                            </IbssButtonRedo>
                                        )}
                                    </PrintContextConsumer>
                                </ReactToPrint>
                            </>
                        }
                    />
                    <CreateVisitorDialog
                        showCreateVisitorDialog={this.state.showAddVisitorModal}
                        closeClicked={(submitted) => this.modalClosed(submitted)}
                    />
                    <div className="page-height-exct-header">
                        <div className="rightPanel-main-content">
                            <div className="table-panel">
                                <IbssPageHeader
                                    title={this.isFlex ? this.labels.HubLabelMyVisitors : this.labels.funcVisitors_S}
                                    selectedPreset={this.state.daysFilter}
                                    presetChanged={(e) => this.dateRangeChanged(e)}
                                    startDate={this.state.bookingStartDate.toJSDate()}
                                    endDate={this.state.bookingEndDate.toJSDate()}
                                    datesDisabled={this.state.dateDisabled}
                                    onStartDateChange={i => this.startDateChanged(i)}
                                    onEndDateChange={i => this.endDateChanged(i)}
                                    presets={[this.labels.HubLabelTomorrow, this.labels.HubLabelThisWeek, this.labels.HubLabelNextWeek, this.labels.HubLabelThisMonth, this.labels.HubLabelNextMonth]}
                                />
                                <Grid container rowSpacing={1} sx={{ display: 'flex', alignItems: 'center', mt: 0, ml: 0 }}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box
                                            sx={{
                                                '& > :not(style)': { mr: 2, my: 1, alignItems: "center" },
                                            }}
                                        >
                                            <IbssFormControl variant="outlined">
                                                <IbssTextField
                                                    type="text"
                                                    size="small"
                                                    placeholder={this.labels.HubLabelSearch}
                                                    value={this.state.searchTerm}
                                                    onChange={(event) => this.handleSearchTermChange(event)}
                                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                                                />
                                            </IbssFormControl>
                                            <IbssButtonRedo color="primary" className="mr-2" variant="contained" onClick={() => this.filterButtonClicked()}>{this.labels.HubLabelFilter}</IbssButtonRedo>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'right' }}>
                                        {this.state.canExport && <IbssButtonRedo color="secondary" className="mr-2" variant="contained" onClick={() => this.downloadVisitsClicked()} >{this.labels.HubButtonExport}</IbssButtonRedo>}
                                        {this.state.canImport && <IbssButtonRedo color="secondary" variant="contained" onClick={() => this.fileUploadModalClosed()}>{this.labels.HubButtonImport}</IbssButtonRedo>}
                                    </Grid>
                                </Grid>
                                <Box component="div" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', my: 1, mr: 0 }}>
                                    <IbssActionButton buttons={actions} />
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    <IbssDataGrid
                                        checkboxSelection
                                        rows={this.filteredVisits}
                                        columns={visitColumns}
                                        onRowSelectionModelChange={e => this.selectionChanged(e)}
                                        rowSelectionModel={this.state.selectedVisitIds}
                                        loading={this.state.isCompleteLoading}
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 25 } },
                                        }}
                                        pageSizeOptions={[25, 50, 100]}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    private renderEdit(row: Visit2): React.ReactNode
    {
        return (
            this.state.canUpdateVisits && !(row.Visit_Status === "Cancelled" || row.Visit_Status === "Completed" || row.Visit_Status === "No Show" || row.Visit_Status === "Auto Cancelled") ?
                <Button onClick={() => this.editVisitButtonClicked(row)}>
                    <IbssSvgIcon sx={{ color: (theme) => theme.palette.text.primary }} className="pointer">
                        <CreateIcon />
                    </IbssSvgIcon>
                </Button> : <p>-</p>
        );
    }
}

const mapStateToProps = (state: any) =>
{
    return {
        currentPageTitle: state.currentPageTitle,
        lightModeTheme: state.lightModeTheme,
        identityProvidersStore: state.identityProviders,
        mainPageTitle: state.mainPageTitle,
    };
};

export interface IProps extends RouterProps, RouteComponentProps, IPropsFromState, IDispatch
{
}

export interface IState
{
    canExport: boolean;
    canImport: boolean;
    canCreateVisits: boolean;
    canUpdateVisits: boolean;
    isRefreshButtonDisabled: boolean;
    searchTerm: string;
    daysFilter: string;
    bookingStartDate: DateTime;
    bookingEndDate: DateTime;
    dateDisabled: boolean;
    selectedVisitIds: GridRowSelectionModel;
    visits: Visit2[];
    isCompleteLoading: boolean;
    cancelButtonEnabled: boolean;
    approveButtonEnabled: boolean;
    denyButtonEnabled: boolean;
    checkInButtonEnabled: boolean;
    checkOutButtonEnabled: boolean;
    printPassButtonEnabled: boolean;
    showDeny: boolean;
    denyComment: string;
    isFileUpload: boolean;
    showPrintPass: boolean;
    file: IFile | undefined;
    filterStatusOption: IFilterStatus[];
    filterValue: string;
    showFilterDialog: boolean;
    selectedHost: IHost;
    dialogSelectedHost: IHost;
    dialogHostName: string;
    showAddVisitorModal: boolean;
    buildingId: number;
    visitStatus: string;
    badgeHtml: string;
    userHasApproveRights: boolean;
    userHasDenyRights: boolean;
    userHasCheckinRights: boolean;
    userHasCheckoutRight: boolean;
}

export interface IFilterStatus
{
    label: string;
    value: string;
}

export interface IHost
{
    label: string;
    email: string;
}

export interface IFile
{
    name: string;
}

export default connect(mapStateToProps)(ListVisits);
